var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _vm.show.includes("exitSought")
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "form-group col-md-12",
                staticStyle: { margin: "0px" }
              },
              [
                _c("label", [_vm._v("Exit Sought")]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group input-group",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.exitSought,
                          expression: "exitSought"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "border-radius": "5px" },
                      attrs: { type: "text", rows: "2", maxlength: "500" },
                      domProps: { value: _vm.exitSought },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.exitSought = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("investorVision")
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "form-group col-md-12",
                staticStyle: { margin: "0px" }
              },
              [
                _c("label", [_vm._v("Investor Vision")]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group input-group",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.investorVision,
                          expression: "investorVision"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "border-radius": "5px" },
                      attrs: { type: "text", rows: "2", maxlength: "500" },
                      domProps: { value: _vm.investorVision },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.investorVision = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("investorFundingGoals")
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "form-group col-md-12",
                staticStyle: { margin: "0px" }
              },
              [
                _c("label", [_vm._v("Investor Funding Goals")]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group input-group",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.investorFundingGoals,
                          expression: "investorFundingGoals"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "border-radius": "5px" },
                      attrs: { type: "text", rows: "2", maxlength: "500" },
                      domProps: { value: _vm.investorFundingGoals },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.investorFundingGoals = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("region")
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "form-group col-md-12",
                staticStyle: { margin: "0px" }
              },
              [
                _c("label", [_vm._v("Region")]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group input-group",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.region,
                          expression: "region"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "border-radius": "5px" },
                      attrs: { type: "text", rows: "2", maxlength: "500" },
                      domProps: { value: _vm.region },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.region = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("entrepreneurialExperience")
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "form-group col-md-12",
                staticStyle: { margin: "0px" }
              },
              [
                _c("label", [_vm._v("Entrepreneurial Experience")]),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group input-group",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entrepreneurialExperience,
                          expression: "entrepreneurialExperience"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "border-radius": "5px" },
                      attrs: { type: "text", rows: "2", maxlength: "500" },
                      domProps: { value: _vm.entrepreneurialExperience },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.entrepreneurialExperience = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("technicalExperience")
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "form-group col-md-12",
                staticStyle: { margin: "0px" }
              },
              [
                _c("label", [_vm._v("Technical Experience")]),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group input-group",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.technicalExperience,
                          expression: "technicalExperience"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "border-radius": "5px" },
                      attrs: { type: "text", rows: "2", maxlength: "500" },
                      domProps: { value: _vm.technicalExperience },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.technicalExperience = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("additionalServices")
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "form-group col-md-12",
                staticStyle: { margin: "0px" }
              },
              [
                _c("label", [_vm._v("Additional Services")]),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group input-group",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.additionalServices,
                          expression: "additionalServices"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "border-radius": "5px" },
                      attrs: { type: "text", rows: "2", maxlength: "500" },
                      domProps: { value: _vm.additionalServices },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.additionalServices = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("applicationProcess")
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "form-group col-md-12",
                staticStyle: { margin: "0px" }
              },
              [
                _c("label", [_vm._v("Application Process")]),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group input-group",
                    staticStyle: { width: "100%" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.applicationProcess,
                          expression: "applicationProcess"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { "border-radius": "5px" },
                      attrs: {
                        type: "url",
                        placeholder: "https://example.com/application-process"
                      },
                      domProps: { value: _vm.applicationProcess },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.applicationProcess = $event.target.value
                        }
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "An exit strategy is the process of disposing of a business asset\n            once specific criteria has been met."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "The motives the investor has with respect to attaining new\n            business assets."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("small", [_vm._v("The providers overall aims.")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [_vm._v("The region of the world the provider operates in.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "Experience the provider have investing and supporting\n            entrepreneurial ventures."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "Experience the provider has supporting technical aspects of\n            ventures."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [_vm._v("Any additional services the provider may provide.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "Link to online application process or description of application\n            instructions"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76224403", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76224403","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/descs.vue
// module id = 190
// module chunks = 0